var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectedNumbers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "65px",
    height: "65px",
    viewBox: "0 0 65 65",
    enableBackground: "new 0 0 65 65",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    transform: "translate(-0.086 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    transform: "translate(0.086 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#B85555",
    strokeWidth: 2,
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-times",
    fill: "#757575",
    d: "M47.781,31.545l2.563-2.562c0.354-0.353,0.354-0.926,0.002-1.28 c-0.001,0-0.002-0.001-0.002-0.001l-1.281-1.281c-0.353-0.354-0.926-0.354-1.279-0.001c0,0-0.001,0-0.002,0.001l-2.562,2.562 l-2.563-2.562c-0.353-0.354-0.926-0.354-1.279-0.001c0,0,0,0-0.001,0.001l-1.28,1.281c-0.354,0.353-0.354,0.926-0.001,1.28 c0.001,0,0.001,0,0.001,0.001l2.561,2.562l-2.562,2.563c-0.354,0.353-0.354,0.926-0.001,1.279c0,0,0.001,0.001,0.001,0.002 l1.281,1.28c0.353,0.354,0.927,0.354,1.28,0.001c0,0,0,0,0-0.001l2.563-2.562l2.563,2.562c0.354,0.354,0.926,0.354,1.279,0.001 c0,0,0.001,0,0.002-0.001l1.28-1.28c0.354-0.354,0.354-0.927,0.001-1.28c0-0.001,0-0.001-0.001-0.001L47.781,31.545z  M27.242,32.445c3.971,0,7.191-3.219,7.191-7.191c0-3.971-3.22-7.191-7.191-7.191c-3.971,0-7.19,3.218-7.191,7.189 c0,3.972,3.219,7.191,7.19,7.192C27.241,32.444,27.242,32.444,27.242,32.445L27.242,32.445z M32.276,34.245h-0.938 c-2.599,1.198-5.592,1.198-8.191,0h-0.939c-4.168,0.001-7.548,3.378-7.551,7.547v2.337c0,1.491,1.209,2.7,2.7,2.7l0,0H37.13 c1.491,0,2.7-1.209,2.7-2.7l0,0v-2.337c-0.002-4.171-3.383-7.551-7.554-7.55V34.245z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedNumbers);
export default __webpack_public_path__ + "static/media/rejectedNumbers.9eea6d70052006e0b894e826e0f4bc70.svg";
export { ForwardRef as ReactComponent };